<template>
  <div class="karta-tile__content">
    <div class="karta-wrapper">
      <div class="karta__state">
        <div class="v-card-h2">Status karty wirtualnej:</div>

        <div class="v-card-h3">{{ virtualCardState }}</div>

        <div v-if="showPhysicalCardState">
          <div class="v-card-h2">Karta fizyczna:</div>

          <div class="v-card-h3">{{ cardState }}</div>
        </div>

        <template v-if="lastRejectedApplication && lastRejectedApplication.reason">
          <div class="v-card-h2 mt-2">Powód odrzucenia wniosku:</div>

          <div class="v-card-h3">{{ lastRejectedApplication.reason }}</div>
        </template>
      </div>

      <div class="v-card-h3">
        <template v-if="!card">
          <v-btn
            v-if="!currentApplication"
            block
            depressed
            primary
            large
            class="primary"
            @click="redirectToApplication"
          >
            Złóż wniosek o kartę
          </v-btn>

          <p v-else>
            <strong>Data złożenia wniosku:</strong>
            {{ currentApplication.created | dateFilter }}
          </p>
        </template>

        <template v-else-if="isBlocked">
          <p>
            <strong>Karta zablokowana do:</strong>
            {{ card.blockEndDate | dateFilter }}
          </p>

          <div v-if="card.blockReason">
            <strong>Powód blokady:</strong>

            <p>{{ card.blockReason }}</p>
          </div>
        </template>

        <template v-else-if="isInactive">
          <div v-if="card.inactiveReason">
            <strong>Powód unieważnienia:</strong>

            <p>{{ card.inactiveReason }}</p>
          </div>

          <v-btn
            v-if="!currentApplication"
            block
            depressed
            primary
            large
            class="primary"
            @click="redirectToApplication"
          >
            Złóż wniosek o kartę
          </v-btn>
        </template>

        <template v-else-if="isExpiring">
          <v-btn
            v-if="!currentApplication"
            block
            depressed
            primary
            large
            class="primary"
            @click="redirectToApplication"
          >
            Przedłuż ważność karty
          </v-btn>

          <p v-else>
            <strong>Data złożenia wniosku:</strong>
            {{ currentApplication.created | dateFilter }}
          </p>
        </template>

        <template v-else-if="card.state === CardState[CardState.NOT_CONFIRMED]">
          <p>W trakcie weryfikacji.</p>

          <p v-if="currentApplication">
            <strong>Data złożenia wniosku:</strong>
            {{ currentApplication.created | dateFilter }}
          </p>
        </template>

        <template v-else-if="card.state === CardState[CardState.ORDERED]">
          <p>
            Czeka na wydruk.
          </p>
        </template>

        <template v-else-if="card.state === CardState[CardState.PRINTED]">
          <p>
            Czeka na przekazanie do punktu odbioru.
          </p>
        </template>

        <template v-else-if="card.state === CardState[CardState.READY]">
          <p>
            Czeka na odbiór.
          </p>
        </template>

        <div v-if="card.physical" class="d-flex mt-4 mr-2 mb-0">
          <strong>Karta fizyczna</strong>
        </div>

        <template v-if="isExpired || isVirtualCardActive || (card && card.state === CardState[CardState.ACTIVE])">
          <div class="d-flex mt-4">
            <p class="mr-2 font-bold mb-0">Ważna do:</p>
            {{ expirationDate }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { dateFilter, CardState, CardStateTranslation } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import { cardMixin } from '@/mixins/cardMixin';

// @vuese
// Informacje o karcie
// @group Home
export default {
  filters: { dateFilter },
  mixins: [cardMixin],
  data() {
    return {
      CardState
    };
  },
  computed: {
    ...mapState({
      profile: state => state.profile.data
    }),
    cardState() {
      const card = this.card;
      if (!card) {
        return 'Brak karty przypisanej do konta';
      }
      if (this.isBlocked) {
        return 'Zablokowana';
      }
      if (
        this.card.state !== CardState[CardState.INACTIVE] &&
        this.card.state !== CardState[CardState.NOT_CONFIRMED] &&
        this.isExpired
      ) {
        return 'Upłynął okres ważności';
      }
      return CardStateTranslation[CardState[card.state]];
    },
    virtualCardState() {
      if (this.isVirtualCardActive && !this.isBlocked) {
        return CardStateTranslation[CardState.ACTIVE];
      }
      return this.cardState;
    },
    showPhysicalCardState() {
      if (this.isBlocked) {
        return;
      }
      return (
        !this.isExpired &&
        this.card &&
        this.card.physical &&
        this.card.state !== CardState[CardState.ACTIVE] &&
        this.card.state !== CardState[CardState.NOT_CONFIRMED]
      );
    }
  },
  methods: {
    // @vuese
    // Przekierowuje do zakładki ze składaniem wniosku
    redirectToApplication() {
      this.$router.push({ name: 'application' });
    }
  }
};
</script>
